import React from "react";
import {
    Box,
    Typography,
    Grid,
    Paper,
    Stack,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import BookSessionButton from "./BookSessionButton";

export default function ProofSecond() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const testimonials = [
        {
            title: "⭐ Testimonial 1",
            text: "“When I first told my boys they were joining the program, they cried and refused to go. My husband even waited outside to comfort them. But after the first session, they came out happy, light, and excited to return.\n\nWhat amazed me most is how clearly they can now identify their feelings - and even help regulate me when I get upset.\n\nThis journey has made a real difference in our home.”",
            author: "— Mother of two boys",
            bgColor: "#A8BDD2",
        },
        {
            title: "⭐ Testimonial 2",
            text: "“My daughter had an amazing time. These sessions truly enhanced her way of thinking and gave her more support and self-confidence.\n\nI recommend it to all my friends. It's such an important psychological foundation for kids.”",
            author: "— S.F.",
            bgColor: "custom.green",
        },
        {
            title: "⭐ Testimonial 3",
            text: "“The impact you've had on my children is something I feel every single day. It would truly be a loss if you stopped.\n\nMy son now expresses his emotions in ways that even help me when I cross my limits.\n\nYou are making a real difference.”",
            author: "— S.K.",
            bgColor: "#F5E8CC",
        },
    ];

    return (
        <Box
            component="section"
            sx={{
                bgcolor: "#fff",
                py: { xs: 3, md: 8 },
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Box width="100%" sx={{ px: { xs: 1, md: 4 } }}>
                <Stack spacing={isMobile ? 2 : 4}>
                    <Box textAlign="center">
                        <Typography
                            variant="h6"
                            sx={{
                                color: "primary.main",
                                fontWeight: 400,
                                fontSize: { xs: 18, md: 22 },
                            }}
                        >
                            Real kids, Real Results
                        </Typography>
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 400,
                                fontSize: { xs: 22, md: 32 },
                                mt: 1,
                            }}
                        >
                            <strong>
                                Proof That Calm, Connected Parenting Is Possible…
                            </strong>
                        </Typography>
                    </Box>
                    <Grid
                        container
                        spacing={isMobile ? 0 : 4}
                        sx={{ px: { xs: 0, md: 4 } }}
                    >
                        {testimonials.map((testimonial, index) => (
                            <Grid item xs={12} md={4} key={testimonial.title}>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        bgcolor: testimonial.bgColor,
                                        p: { xs: 2, md: 3 },
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "100%",
                                        mt: { xs: index === 0 ? 0 : 2, md: 0 },
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: { xs: 18, md: 20 },
                                            color: "text.primary",
                                            mb: 1,
                                        }}
                                    >
                                        {testimonial.title}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: { xs: 16, md: 18 },
                                            color: "text.primary",
                                            whiteSpace: "pre-line",
                                        }}
                                    >
                                        {testimonial.text}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: "primary.main",
                                            fontWeight: 400,
                                            fontSize: { xs: 18, md: 24 },
                                            mt: 2,
                                        }}
                                    >
                                        {testimonial.author}
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                    <Box textAlign={isMobile ? "center" : "left"}>
                        <BookSessionButton />
                    </Box>
                </Stack>
            </Box>
        </Box>
    );
}
